import { useEffect, useState } from 'react';

// Verzoegert die Aktualisierung eines Werts. 300ms ist Standard fuer Suche.
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
